var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonReportableSpills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1800_27213)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 12,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_1800_27213)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1800_27213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9462 28.8608C45.3666 28.2234 44.584 27.9022 43.62 27.9006C41.9965 27.5007 35.6847 25.9738 34.5621 26.0003C32.6743 26.0445 30.9723 28.6846 30.631 30.3374C30.2912 31.9824 30.4376 35.504 33.232 36.1588L41.2144 39.0696C41.6707 39.2992 42.1929 39.43 42.7947 39.43C43.0233 39.43 43.2622 39.4111 43.5124 39.3793C45.7205 39.0804 46.9456 35.6438 47.0125 32.4026C47.032 31.5371 46.9155 29.9231 45.9462 28.8607L45.9462 28.8608ZM34.4458 32.132L33.0023 31.6549C32.7804 31.0363 33.7131 28.3679 34.3113 28.2723L34.6894 31.1799C34.4458 31.3687 34.4007 31.7039 34.4458 32.1322V32.132ZM34.9782 31.5371C35.3105 31.5606 35.4218 32.0596 35.4218 32.4186C35.4218 32.776 35.3329 33.1334 35.0664 33.0861C34.8007 33.0374 34.6668 32.2029 34.6668 32.2029C34.6452 32.5836 34.6452 31.5118 34.9782 31.5371H34.9782ZM34.8004 35.4205L34.8443 33.4181C34.8443 33.4181 35.1997 33.7519 35.4657 33.4891L36.7091 36.0863C36.2432 36.4453 35.0448 35.9194 34.8004 35.4204L34.8004 35.4205ZM37.22 32.9192C37.1526 32.9427 35.6914 32.5051 35.6914 32.5051C35.7549 32.2515 35.6691 31.6755 35.3568 31.3922L36.4837 29.133C36.7892 28.7427 37.6532 32.7648 37.22 32.9192ZM46.2016 32.3839C46.1421 35.2191 45.0831 38.2873 43.411 38.5123C42.3385 38.657 41.5104 38.4383 40.9706 37.8573C40.3955 37.2388 40.1051 36.192 40.1081 34.7482C40.1103 32.7726 41.1305 28.859 43.4763 28.7724L43.61 28.7694C44.3528 28.7694 44.9414 29.0054 45.3655 29.4715C46.1554 30.3359 46.2139 31.7949 46.2017 32.3837L46.2016 32.3839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4796 39.1354C56.7157 40.1727 54.8757 41.0323 53.9989 41.7661C53.1222 42.4997 51.1477 43.6159 48.5938 45.0496C46.0396 46.4836 42.8348 47.5669 40.7554 47.0096C38.6772 46.4508 37.1634 46.3562 35.3958 47.5196C33.6298 48.6828 32.0113 47.5352 31.8178 46.1658C31.6243 44.7945 35.3368 42.4352 37.1326 42.5939C38.5569 42.7213 41.2706 41.2039 42.6738 40.8874C43.2198 40.763 44.1684 40.7471 45.7348 40.1269C47.3031 39.5051 47.9035 36.9409 48.6904 36.5474C49.633 36.0785 51.4641 36.8151 51.9628 36.9834C52.722 37.2385 56.2409 38.0995 56.4796 39.1354V39.1354Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1800_27213",
    x: 0.5,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.564706 0 0 0 0 0.690196 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1800_27213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1800_27213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1800_27213",
    x: 24.5,
    y: 24,
    width: 38,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1800_27213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1800_27213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1800_27213",
    x1: 43.5,
    y1: 12,
    x2: 43.5,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B4F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B325F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonReportableSpills);
export default __webpack_public_path__ + "static/media/NonReportableSpills.4f44e51edbe93cacabdc29bd75a31a27.svg";
export { ForwardRef as ReactComponent };